var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-box",style:(`height: ${_vm.height}px; min-height: ${_vm.height}px`)},[(_vm.loading)?_c('v-progress-circular',{staticClass:"mr-2",attrs:{"indeterminate":"","color":"black","size":16,"width":"2"}}):_vm._e(),_vm._v(_vm._s(_vm.loading ? "데이터를 불러오는 중입니다." : _vm.msg)+" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }